import React, { Component } from 'react'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import {
  Card,
  Icon,
  MenuItem,
  IconButton,
  TextField,
  InputAdornment,
  ClickAwayListener,
  Button,
  Collapse,
  Typography,
  Fade,
  Grow,
  Zoom,
  Slide,
  Grid,
  ButtonBase
} from '@material-ui/core'
import Scrollbar from 'react-perfect-scrollbar'
import ActionPlanBoardCard from './ActionPlanBoardCard'
import { Trans } from '@lingui/macro'

class ActionPlanColumn extends Component {
  state = {
    shouldOpenTitleEditor: false,
    shouldOpenAddCard: false,
    minimized: false,
    cardTitleText: '',
    columnTitleText: ''
  }

  componentDidMount () {
    if (
      this.props.column.title === 'On hold' ||
      this.props.column.title === 'Selected'
    ) {
      this.setState({ minimized: true })
    }
  }

  handleChange = event => {
    if (event.key === 'Enter' && !event.shiftKey) {
      this.props.handleAddNewCard(
        this.state.cardTitleText,
        this.props.columnIndex
      )
      this.openTitleEditor(false)
      this.openAddCard(false)
    } else this.setState({ [event.target.name]: event.target.value })
  }

  openTitleEditor = value => {
    this.setState({ shouldOpenTitleEditor: value })
  }

  openAddCard = value => {
    this.setState({ shouldOpenAddCard: value })
  }

  titleToIcon = {
    'In Progress': 'hourglass_empty',
    Done: 'check',
    'On hold': 'close'
  }

  render () {
    let { shouldOpenAddCard, cardTitleText } = this.state
    let {
      cardActions,
      columns,
      column,
      deleting,
      columnIndex,
      minimizedFull,
      handleColumnMinimize
    } = this.props

    const iconString = this.titleToIcon[column.title]
    return (
      <Card
        style={{
          maxWidth: this.state.minimized && !minimizedFull ? '55px' : '100%',
          flexGrow: 1,
          flexBasis: '20%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderLeft: columnIndex === 0 ? '1px solid' : null,
          borderRight: '1px solid',
          borderBottom: '1px solid',
          borderTop: '1px solid',
          borderRadius: 3,
          borderColor: '#e2e2e2'
        }}
      >
        <ButtonBase
          onClick={() => {
            handleColumnMinimize(!this.state.minimized, columnIndex)
            this.setState({ minimized: !this.state.minimized })
          }}
          style={{ padding: 0 }}
        >
          <Grid
            container
            justify='center'
            alignItems='center'
            style={{ height: '70px' }}
          >
            {!this.state.minimized ? (
              <h4
                style={{
                  textAlign: 'center',
                  marginBottom: 15,
                  marginTop: 15
                }}
              >
                <Trans id={column.title} />
              </h4>
            ) : (
              <Icon>expand_more</Icon>
            )}
            {Boolean(!this.state.minimized && iconString) && (
              <Icon style={{ marginLeft: 10 }}>{iconString}</Icon>
            )}
          </Grid>
        </ButtonBase>

        <div
          style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
        >
          <div
            variant='contained'
            style={{
              backgroundColor: '#10708A',
              color: 'white',
              height: '20px',
              width: '100%'
            }}
          ></div>
          <Droppable
            droppableId={column.title}
            direction='vertical'
            type='card'
            isDropDisabled={this.state.minimized}
          >
            {(provided, snapshot) => (
              <div ref={provided.innerRef} style={{ flexGrow: 1 }}>
                <Collapse in={!this.state.minimized}>
                  {!this.state.minimized &&
                    column.actions.map((card, index) => (
                      <Draggable
                        key={card.id}
                        draggableId={'draggableId' + card.id}
                        index={index}
                        type='card'
                      >
                        {(provided, snapshot) => (
                          <Card
                            onClick={() => {
                              console.log('e')
                              cardActions.openDialog({
                                ...card,
                                columnIndex: column.index,
                                cardIndex: index
                              })
                            }}
                            className='list-column__card borderborder-radius-4 bg-light-gray'
                            elevation={snapshot.isDragging ? 10 : 3}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                              margin: 4
                            }}
                          >
                            <ActionPlanBoardCard
                              deleting={deleting}
                              columns={columns}
                              card={card}
                              index={index}
                              cardActions={cardActions}
                              column={column}
                            ></ActionPlanBoardCard>
                          </Card>
                        )}
                      </Draggable>
                    ))}

                  {provided.placeholder}
                </Collapse>

                {this.state.minimized && (
                  <Slide in={this.state.minimized} direction='up'>
                    <div>
                      {iconString && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 10
                          }}
                        >
                          <Icon>{iconString}</Icon>
                        </div>
                      )}
                      <div style={{ paddingTop: minimizedFull ? 65 : 50 }}>
                        <h4
                          className='nowrap'
                          style={{
                            textAlign: 'center',
                            transform: 'rotate(90deg)',
                            marginBottom: 0
                          }}
                        >
                          <Trans id={column.title} /> {column.actions.length}
                        </h4>
                      </div>
                    </div>
                  </Slide>
                )}
              </div>
            )}
          </Droppable>
        </div>
      </Card>
    )
  }
}

export default ActionPlanColumn
